/**
 * Created by Ning Jiang on 11/24/2016.
 */

import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";
import {WinRatioType} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";

export class RomanEmpireSoundConfig implements ISoundConfig {

    public static instance: RomanEmpireSoundConfig = new RomanEmpireSoundConfig();
    AS_WIN:string="asWin";
    AS_WIN_BIG:string="asWinBig";
    MAIN_GAME_AMBIANCE_1: string = "background-music-main1";
    MEDIUM_AND_LARGE_WIN: string = "background-music-main2";
    REEL_LANDING: string = "reelLanding";

    // REELS_SPIN_START?:string[];
    REELS_SPINNING_START_ON_SPIN_START: string = "reelsSpinning";
    REELS_DEFAULT_BOUNCE: string[] = []; // null it becoz need to play bounce differently
    // REELS_DEFAULT_STOP?:string[];

    //win sounds
    COUNT_UP : string = "countup";
    COUNT_UP_ENDS : string = "countupEnds";
    WIN_LARGE : string = "winLarge";
    WIN_MEDIUM : string = "winMedium";
    WIN_SMALL : string = "winSmall";
    WIN_SYMBOL_HIGHLIGHT : string = "winSymbolHighlight";
    WIN_TINY : string = "winTiny";

    //scatter
    SCATTER : string = "scatter";
    SCATTER_ANTICIPATION : string = "scatterAnticipation";
    SCATTER_ANTICIPATION_ENDS : string = "scatterAnticipationEnds";
    SCATTER_ANTICIPATION_FAILS : string = "scatterAnticipationFail";
    SCATTER_ANTICIPATION_SWEEP : string = "scatterAnticipationSweep";
    SCATTER_FS : string = "scatterFS";
    FS_START : string = "fsStart";
    FS_INTRO : string = "fsIntro";
    BACKGROUND_MUSIC_FS_INTRO : string = "background-music-fs-intro";
    BACKGROUND_MUSIC_FS : string = "background-music-fs";
    FS_OUTRO : string = "fsOutro";
    FS_OUTRO_CONTINUE_BTN : string = "fsOutroContinueButton";

    //random BOTH WAYS feature
    RANDOM_FEATURE_WAYS_INTRO : string = "randomFeatureWaysIntro";
    RANDOM_FEATURE_WAYS_ENDS : string = "randomFeatureWaysEnds";

    //Bigwin sounds
    BIG_WIN_INITIAL_WIN : string = "bigwinInitialWin";
    BIG_WIN_SHAKE : string = "bigwinShake";
    BIG_WIN_LEVEL : string = "bigwinLevel";
    BIG_WIN_ENDS : string = "bigwinEnds";

    //randomFeatureBase
    RFB_LOCK : string = "randomFeatureBaseLock";
    RFB_LOCK_EXPLODE : string = "randomFeatureBaseLockExplode";
    RFB_WILDS : string = "randomFeatureBaseWilds";
    RFB_MULTI_CLOUD : string = "randomFeatureBaseMultiCloud";
    RFB_MULTI_CLOUD_EXPLODE : string = "randomFeatureBaseMultiCloudExplode";
    RFB_MULTI_HIGHLIGHT : string = "randomFeatureBaseMultiHighlight";

    //FS sound
    FS_SCATTER_EXPLODE : string = "fsScatterExplode";
    FS_SCATTER_TO_SCATTER : string = "fsScatterToScatter";
    FS_SCATTER_MOVES : string = "fsScatterMoves";
    FS_SCATTER_FIRE : string = "fsScatterFire";
    FS_SCATTER_EXPLODE_MULTIPLIER : string = "fsScatterExplodeMultiplier";
    FS_SCATTER_SHOOT_FIREBALL : string = "fsScatterShootFireball";
    FS_SCATTER_MULTIPLIER_UPDATE : string = "fsScatterMultiplierUpdate";
    FS_SCATTER_LAST_SPIN : string = "scatterFSLastSpin";
    FS_WIN_LINE : string = "fsWinLine";

    ANIMAL_LEOPARD : string = "animalLeopard";
    ANIMAL_SNAKE : string = "animalSnake";

    constructor() {
        if (RomanEmpireSoundConfig.instance) {
            throw new Error("RomanEmpireSoundConfig.constructor() - Instantiation failed: Singleton.");
        }
    }

    static getNormalWinSoundName(type:WinRatioType):string | null {
        switch(type) {
            case WinRatioType.TINY:
                return RomanEmpireSoundConfig.instance.WIN_TINY;
            case WinRatioType.SMALL:
                return RomanEmpireSoundConfig.instance.WIN_SMALL;
            case WinRatioType.MEDIUM:
                return RomanEmpireSoundConfig.instance.WIN_MEDIUM;
            case WinRatioType.LARGE:
                return RomanEmpireSoundConfig.instance.WIN_LARGE;
            default:
                return null;
        }
    }
}